import logUtil from 'utils/log'
import updateGiftingModeGiftAction from 'modules/gift/redux/actions/update-gifting-mode'
import persistInformationGiftAction from 'modules/gift/redux/actions/persist-information'
import isInGiftingModeGiftSelect from 'modules/gift/redux/selectors/is-in-gifting-mode'

export default function startGiftingModeGiftAction () {
  return (dispatch, getState) => {
    logUtil('startGiftingModeGiftAction').debug('[start]')
    if (isInGiftingModeGiftSelect(getState())) {
      logUtil('startGiftingModeGiftAction').debug('[noop] already in gifting mode')
      return
    }
    dispatch(updateGiftingModeGiftAction(true))
    dispatch(persistInformationGiftAction())
    logUtil('startGiftingModeGiftAction').debug('[done]')
  }
}
